export enum PageNames {
  privateNumbers = 'privateNumbers',
  systemNumbers = 'systemNumbers',
  allPrivateNumberSendLimit = 'allPrivateNumberSendLimit',
  smsSenderAgents = 'smsSenderAgents',
  customerDomains = 'customerDomains',
  blackList = 'blackList',
  menus = 'menus',
  bulkNumberInformation = 'bulkNumberInformation',
  bulkNumberInformation2 = 'bulkNumberInformation2',
  organizations = 'organizations',
  organizationCustomFields = 'organizationCustomFields',
  userPersonalInfo = 'userPersonalInfo',
  userOrganizationalInfo = 'userOrganizationalInfo',
  activeSessions = 'activeSessions',
  resellerUsers = 'resellerUsers',
  resellerOrganization = 'resellerOrganization',
  userLogins = 'userLogins',
  userPasswordHistory = 'userPasswordHistory',
  userImpersonated = 'userImpersonated',
  valueOfPurchases = 'valueOfPurchases',
  userPoints = 'userPoints',
  userValueOfPurchaseStrategies = 'userValueOfPurchaseStrategies',
  userValueOfPurchasePoints = 'userValueOfPurchasePoints',
  alertSetting = 'alertSetting',
  userAuthentication = 'userAuthentication',
  groupPrice = 'groupPrice',
  automaticResend = 'automaticResend',
  sendSMS = 'sendSMS',
  sendSMSFromMap = 'sendSMSFromMap',
  sendSmsFromMap = 'sendSmsFromMap',
  sendSMSFromMap2 = 'sendSMSFromMap2',
  sendQueue = 'sendQueue',
  currentUserSendQueue = 'currentUserSendQueue',
  resellerSendQueue = 'resellerSendQueue',
  usersSendQueue = 'usersSendQueue',
  inboxes = 'inboxes',
  usersInboxes = 'usersInboxes',
  inboxGroups = 'inboxGroups',
  occasionScheduledMessage = 'occasionScheduledMessage',
  phonebook = 'phonebook',
  informationUsersSeen = 'informationUsersSeen',
  createSmsInformation = 'createSmsInformation',
  phonebookFileProgresses = 'phonebookFileProgresses',
  informations = 'informations',
  contactsByCellPhone = 'contactsByCellPhone',
  panelDocumentations = 'panelDocumentations',
  smsTemplate = 'smsTemplate',
  smsTemplateGroup = 'smsTemplateGroup',
  accountInformation = 'accountInformation',
  bankOnlineGateways = 'bankOnlineGateways',
  payments = 'payments',
  resellerPayments = 'resellerPayments',
  newPayment = 'newPayment',
  chequePayments = 'chequePayments',
  resellerChequePayments = 'resellerChequePayments',
  zones = 'zones',
  guilds = 'guilds',
  kibanaDashboards = 'kibanaDashboards',
  systemSetting = 'systemSetting',
  panelSetting = 'panelSetting',
  resellers = 'resellers',
  resellerOrganizations = 'resellerOrganizations',
  resellerTarget = 'resellerTarget',
  publicReceiveKeywords = 'publicReceiveKeywords',
  privateNumberSendLimit = 'privateNumberSendLimit',
  privateReceiveKeywords = 'privateReceiveKeywords',
  transferPrivateNumbers = 'transferPrivateNumbers',
  roles = 'roles',
  organizationTransactions = 'organizationTransactions',
  resellerOrganizationTransactions = 'resellerOrganizationTransactions',
  sendLimits = 'sendLimits',
  outboxTransactions = 'outboxTransactions',
  dynamicSendReceivers = 'dynamicSendReceivers',
  sendReceivers = 'sendReceivers',
  superAdminAudits = 'superAdminAudits',
  rulesAudits = 'rulesAudits',
  apiAudits = 'apiAudits',
  aggregators = 'aggregators',
  webhook = 'webhook',
  apiToken = 'apiToken',
  otp = 'otp',
  allIpRules = 'allIpRules',
  ipRules = 'ipRules',
  clientRules = 'clientRules',
  creditNotification = 'creditNotification',
  modules = 'modules',
  modulesOrganizations = 'modulesOrganizations',
  paymentsForConfirm = 'paymentsForConfirm',
  resellerPaymentsForConfirm = 'resellerPaymentsForConfirm',
  filterWords = 'filterWords',
  userOutboxMessages = 'userOutboxMessages',
  currentUserOutboxMessages = 'currentUserOutboxMessages',
  usersOutboxMessages = 'usersOutboxMessages',
  resellerOutboxMessages = 'resellerOutboxMessages',
  resellersOutboxMessages = 'resellersOutboxMessages',
  sendSMSWithPhonebook = 'sendSMSWithPhonebook',
  myGroupPriceDetails = 'myGroupPriceDetails',
  sendBulkSMS = 'sendBulkSMS',
  sendBulkSMS2 = 'sendBulkSMS2',
  dynamicTemplate = 'dynamicTemplate',
  dynamicSendSms = 'dynamicSendSms',
  sendP2pSms = 'sendP2pSms',
  sendP2pTrackingNumberSms = 'sendP2pTrackingNumberSms',
  sendOccasionSms = 'sendOccasionSms',
  fastSendSmsPatternByPhonebook = 'fastSendSmsPatternByPhonebook',
  surveyParser = 'surveyParser',
  competitionParser = 'competitionParser',
  textParsers = 'textParsers',
  safeIps = 'safeIps',
  confirmUserSafeIps = 'confirmUserSafeIps',
  whiteMessagesList = 'whiteMessagesList',
  organizationWhiteMessages = 'organizationWhiteMessages',
  sendWhiteMessage = 'sendWhiteMessage',
  currentOrganizationSentCountStatistics = 'currentOrganizationSentCountStatistics',
  currentUserSentCountStatistics = 'currentUserSentCountStatistics',
  sentCountStatistics = 'sentCountStatistics',
  currentOrganizationSendStatusStatistics = 'currentOrganizationSendStatusStatistics',
  currentUserSendStatusStatistics = 'currentUserSendStatusStatistics',
  sendStatusStatistics = 'sendStatusStatistics',
  currentOrganizationOperatorStatistics = 'currentOrganizationOperatorStatistics',
  currentUserOperatorStatistics = 'currentUserOperatorStatistics',
  operatorStatistics = 'operatorStatistics',
  complexStatistics = 'complexStatistics',
  currentOrganizationComplexStatistics = 'currentOrganizationComplexStatistics',
  currentUserComplexStatistics = 'currentUserComplexStatistics',
  currentUserTodayStatistics = 'currentUserTodayStatistics',
  currentOrganizationTodayStatistics = 'currentOrganizationTodayStatistics',
  todayStatistics = 'todayStatistics',
  todayStatisticsByOperator = 'todayStatisticsByOperator',
  currentOrganizationStatisticsByPartLength = 'currentOrganizationStatisticsByPartLength',
  currentUserStatisticsByPartLength = 'currentUserStatisticsByPartLength',
  statisticsByPartLength = 'statisticsByPartLength',
  sentCountAggregateCompareStatistics = 'sentCountAggregateCompareStatistics',
  sentCountSeasonCompareStatistics = 'sentCountSeasonCompareStatistics',
  sentStatusAggregateCompareStatistics = 'sentStatusAggregateCompareStatistics',
  sentStatusSeasonCompareStatistics = 'sentStatusSeasonCompareStatistics',
  currentUserOperatorAggregateCompareStatistics = 'currentUserOperatorAggregateCompareStatistics',
  currentOrganOperatorAggregateCompareStatistics = 'currentOrganOperatorAggregateCompareStatistics',
  superAdminSentStatusSeasonCompareStatistics = 'superAdminSentStatusSeasonCompareStatistics',
  superAdminSentStatusAggregateCompareStatistics = 'superAdminSentStatusAggregateCompareStatistics',
  currentUserOperatorSeasonCompareStatistics = 'currentUserOperatorSeasonCompareStatistics',
  currentOrganOperatorSeasonCompareStatistics = 'currentOrganOperatorSeasonCompareStatistics',
  superAdminOperatorSeasonCompareStatistics = 'superAdminOperatorSeasonCompareStatistics',
  superAdminOperatorAggregateCompareStatistics = 'superAdminOperatorAggregateCompareStatistics',
  currentOrganSentStatusSeasonCompareStatistics = 'currentOrganSentStatusSeasonCompareStatistics',
  currentOrganSentStatusAggregateCompareStatistics = 'currentOrganSentStatusAggregateCompareStatistics',
  superAdminSentCountSeasonCompareStatistics = 'superAdminSentCountSeasonCompareStatistics',
  superAdminSentCountAggregateCompareStatistics = 'superAdminSentCountAggregateCompareStatistics',
  currentOrganSentCountSeasonCompareStatistics = 'currentOrganSentCountSeasonCompareStatistics',
  currentOrganSentCountAggregateCompareStatistics = 'currentOrganSentCountAggregateCompareStatistics',
  campaigns = 'campaigns',
  packageSales = 'packageSales',
  createPackageOrganization = 'createPackageOrganization',
  packageOrganizations = 'packageOrganizations',
  packageChildrenOrganizations = 'packageChildrenOrganizations',
  landingPage = 'landingPage',
  landingPageList = 'landingPageList',
  readyTemplates = 'readyTemplates',
  shortLinks = 'shortLinks',
  descendantShortLinks = 'descendantShortLinks',
  voiceMessagesList = 'voiceMessagesList',
  voiceMessagesGroupList = 'voiceMessagesGroupList',
  mediasList = 'mediasList',
  discount = 'discount',
  privateNumbersPrice = 'privateNumbersPrice',
  privateNumbersPriceForUser = 'privateNumbersPriceForUser',
  privateNumberBuyRequests = 'privateNumberBuyRequests',
  childrenPrivateNumberBuyRequests = 'childrenPrivateNumberBuyRequests',
  excelRequest = 'excelRequest',
  frontAudits = 'frontAudits',
  plansManagement = 'plansManagement',
  buyPlanModule = 'buyPlanModule',
  buyPlanPackage = 'buyPlanPackage',
  zonePostalCodes = 'zonePostalCodes',
  sendZonePostalCode = 'sendZonePostalCode',
  sendSmartSmsToResidents = 'sendSmartSmsToResidents',
  sendSmartSMS = 'sendSmartSMS',
  customPlace = 'customPlace',
  smartSend = 'smartSend',
  resellerSmartSend = 'resellerSmartSend',
  smartSmsRequestConfirmData = 'smartSmsRequestConfirmData',
  sendP2pSmartSms = 'sendP2pSmartSms',
  smartSmsCampaign = 'smartSmsCampaign',
  smartSmsClub = 'smartSmsClub',
  smartDetail = 'smartDetail',
  customerClubDevice = 'customerClubDevice',
  calendarEvent = 'calendarEvent',
  numbersAggregator = 'numbersAggregator',
  numbersBlackList = 'numbersBlackList',
  queuesStatistics = 'queuesStatistics',
  currentOrganizationResellersStatistics = 'currentOrganizationResellersStatistics',
  refundDeliveryStatus = 'refundDeliveryStatus',
  sendSmartDetailsByDelivery = 'sendSmartDetailsByDelivery',
  domainConfiguration = 'domainConfiguration',
  contacts = 'contacts',
  documentsManagement = 'documentsManagement',
  customerClubDeviceNumbers = 'customerClubDeviceNumbers',
  fieldsManagement = 'fieldsManagement',
  formsManagement = 'formsManagement',
  smartSmsNumberClasses = 'smartSmsNumberClasses',
  checkNumberClassResponses = 'checkNumberClassResponses',
  onlineSurveyList = 'onlineSurveyList',
  onlineSurveyResponses = 'onlineSurveyResponses',
  onlineSurveyStatistics = 'onlineSurveyStatistics',
  processTextResults = 'processTextResults',
}
